<template>
  <div v-if='address != null'>
      <h1 class="pageHeader">
        <span class="pageHeader__title">PLATINCOIN address</span>
      </h1>

      <div class="blockBorder">
        <div class="row">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12 col-xl-8 mb-5">
                <table class="table" id="addressSummary">
                  <tbody>
                    <tr class="table__header">
                      <td class="table__title table__title--capitalize" colspan="2">Summary</td>
                    </tr>
                    <tr class="table__row">
                      <td class="table__cell txt-gray">Address</td>
                      <td class='table__cell txt-white'>
                        <router-link :to="{ path: '/address/' + address.address }"
                                     class="link">
                          {{ address.address }}
                        </router-link>
                      </td>
                    </tr>
                    <tr class="table__row">
                      <td class="table__cell txt-gray">No. Transactions</td>
                      <td class="table__cell txt-white">{{ address.totalCount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-lg-12 col-xl-4 mb-5">
                <table class="table" id="addressStats">
                  <tbody>
                    <tr class="table__header">
                      <td class="table__title table__title--capitalize" colspan="2">Stats</td>
                    </tr>
                    <tr class="table__row">
                      <td class="table__cell txt-gray">Total Received</td>
                      <td class="table__cell txt-white">{{ address.totalReceived.toFixed(5) }} PLC</td>
                    </tr>
                    <tr class="table__row">
                      <td class="table__cell txt-gray">Total Sent</td>
                      <td class="table__cell txt-white">{{ address.totalSent.toFixed(5) }} PLC</td>
                    </tr>
                    <tr class="table__row">
                      <td class="table__cell txt-gray">Total Balance</td>
                      <td class="table__cell txt-white">{{ address.totalBalance.toFixed(5) }} PLC</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-lg-3 mb-4 mb-lg-0">
            <div class="grid grid--jCenter">
              <div id="addressQR" class="qr">
                <qrcode :value="address.address"
                        :options="{ errorCorrectionLevel: 'H', version: 5, scale: 4.5 }"></qrcode>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="addressVisual">
        <template v-if='txs.length > 0'>
          <h3 class="table__header table__header--transactions table__title--capitalize">
            <img class="icon" src="../assets/img/check-box.png" alt="check-box">Transactions</h3>
          <div v-for='tx in txs'
               :key='tx.txid'
               class='txdiv'>
            <table class='table table--awd'>
              <tbody>
                <tr class="table__header">
                  <td class='table__title table__title--lowercase hidden-xs-down' colspan='3'>
                    <router-link :to="{ path: '/tx/' + tx.txid }"
                                 class="link link--gray">
                      {{ tx.txid }}
                    </router-link>
                    <span class="table__txRight"></span>
                  </td>
                </tr>

                <tr class="table__header">
                  <td class='table__title table__title--lowercase hidden-sm-up'>
                    <router-link :to="{ path: '/tx/' + tx.txid }"
                                 class="link link--gray">
                      {{ tx.txid }}
                    </router-link>
                    <span class="table__txRight"></span>
                  </td>
                </tr>

                <tr class="table__row table__row--trasparent">
                  <td class='table__cell table__cell--input txt-white'>
                    <template v-if="tx.inputs.length == 0 || tx.inputs[0].length == 0">
                      Coinbase (newly generated coins)
                    </template>
                    <template v-else>
                      <template v-for="input in tx.inputs">
                        <router-link v-if="input != moneybox"
                                     :key='input'
                                     :to="{ path: '/address/' + input }"
                                     class="link"> {{ input }} <br/> </router-link>
                      </template>
                    </template>
                  </td>
                  <v-iarrow :tx="tx"></v-iarrow>
                  <td class='table__cell table__cell--output txt-white'>
                    <template v-for="(output, index) in tx.outputs">
                      <template v-if="output.address != moneybox || tx.type && tx.type == 'coinbase'">
                        <router-link v-if="output.address != moneybox"
                                     :key="index + 'link'"
                                     :to="{ path: '/address/' + output.address }"
                                     class="link">
                          {{ output.address }}
                        </router-link>
                        <router-link v-else-if="tx.type && tx.type == 'coinbase'"
                                     :key="index + 'link'"
                                     :to="{ path: '/address/' + output.address }"
                                     class="link"> PLC Minting Depot </router-link>
                        <span :key="index + 'plc'">
                          <span class="table__txRight table__txRight--sm-left txt-white">
                            <template v-if="index == 0 && tx.type == 'minting'">
                              {{ output.value - tx.additional.minting.minted | formatPlc }}
                            </template>
                            <template v-else>
                              {{ output.value | formatPlc }}
                            </template>
                          </span>
                        </span>
                        <br :key="index + 'plc'"/>
                      </template>
                    </template>
                    <template v-if="tx.type == 'minting'">
                      Minted Coins
                      <span :key="index + 'plc'">
                        <span class="table__txRight table__txRight--sm-left txt-white">
                          {{ tx.additional.minting.minted | formatPlc }}
                        </span>
                      </span>
                      <br :key="index + 'plc'"/>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="confirmation confirmation--sm-center">
              <button v-if="tx.confirmations > 0" class="confirmation__button confirmation__button--normal"> {{ tx.confirmations }} Confirmations</button>
              <button v-else class='confirmation__button confirmation__button--negative'>Unconfirmed Transaction!</button>
            </div>
          </div>
          <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
            <span slot="no-more"> </span>
            <span slot="no-results"> No results :( </span>
            <span slot="no-more"> No more results :( </span>
          </infinite-loading>
        </template>
      </div>
  </div>
</template>

<script>
import ApiService from '../service/ApiService'
import InfiniteLoading from 'vue-infinite-loading'
let isTimer = null

export default {
  name: 'Address',

  data: () => ({
    address: null,
    txs: [],
    last_txid: null,
    last_time: null,
    moneybox: ''
  }),

  computed: {
    lastTx () {
      return this.txs[this.txs.length - 1]
    },

    newestTx () {
      return this.txs[0]
    }
  },

  watch: {
    '$route' (to, from) {
      this.txs = []
      this.address = null
      this.last_txid = null
      this.last_time = null
      this.fetchAddress()
    }
  },

  created () {
    this.fetchAddress()
    isTimer = setInterval(this.fetchAddress, 15000)
  },

  beforeDestroy () {
    clearInterval(isTimer)
  },

  methods: {
    updateLastTx () {
      const last_tx = this.txs[this.txs.length - 1]
      if (last_tx) {
        this.last_txid = last_tx.txid
        this.last_time = last_tx.time
      }
    },
    async fetchAddress () {
      try {
        const info = await ApiService.getInfo()
        if (!info) {
          throw Error('Failed to load information')
        }
        this.moneybox = info.moneybox

        const response = await ApiService.searchById(this.$route.params.id)
        if (!response) {
          this.$router.push({ path: '/not-found' })
          return
        }
        const { transactions, ...address } = response.result
        this.address = address
        if (this.txs.length > 0) {
          const newestTxIndex = transactions.findIndex(
            tx => tx.txid === this.newestTx.txid
          )
          if (newestTxIndex > 0) {
            this.txs.unshift(...transactions.slice(0, newestTxIndex))
          }
        } else {
          this.txs.unshift(...transactions)
        }
        this.updateLastTx()
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    },
    async infiniteHandler ($state) {
      try {
        let count = 20
        const response = await ApiService.getAddress(
          this.$route.params.id,
          this.last_txid,
          count
        )
        if (response.length === 0) {
          $state.complete()
          return
        }
        for (let new_tx of response[0].transactions) {
          count -= 1
          this.txs.push(new_tx)
        }
        this.updateLastTx()
        if (count > 0) {
          $state.complete()
        } else {
          $state.loaded()
        }
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    }
  },

  components: {
    InfiniteLoading
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Address.vue